import React from "react"
import { Link, Outlet } from "react-router-dom"

import Mainslide from "../class/Mainslide"
import Aboutnav from "./about/About-nav"
import AboutEvent from "./about/About-Event"
import AboutNews from "./about/About-News"
import AboutSNS from "./about/About-SNS"

import ScrollPosition from "../hook/ScrollPosition"






const About = () => {
   const scrollPosition = ScrollPosition()
   return (
      <div id='About'>
         <Mainslide />
         <section id='section'>
            <div className='inner'>
               <Aboutnav />
               <Outlet />
            </div>
            <div className={`About-Floor transPosition ${scrollPosition >= 1100 ? 'originPosition' : ''}`}>
               <div className="inner">
                  <h1>Floor Info</h1>
                  <Link to="/Shop">
                     <div>
                        <img className="img1" src={require("../img/about7.jpg")} alt="층별안내 이미지" />
                        <img className="img2" src={require("../img/about8.jpg")} alt="층별안내 이미지" />
                     </div>
                  </Link>
               </div>
            </div>
            <div className={`About-News transPosition ${scrollPosition >= 2000 ? 'originPosition' : ''}`}>
               <div className='inner'>
                  <AboutNews/>
               </div>
            </div>
            <div className={`About-Event transPosition ${scrollPosition >= 3000 ? 'originPosition' : ''}`}>
               <AboutEvent />
            </div>
            <div className={`About-SNS transPosition ${scrollPosition >= 4000 ? 'originPosition' : ''}`}>
               <AboutSNS />
            </div>
         </section>
      </div>
   )
}

export default About
